const GLOBAL_TEST_IDS = {
  visibilityOffIcon: "visibilityOffIcon",

  visibilityIcon: "visibilityIcon",

  circularProgress: "circularProgress",
};

export default GLOBAL_TEST_IDS;
